import { AdCreatorType, UserKindEnum, UserModel } from '@/types';
import { Section } from '@/components/PdfManager/PdfDocument/VerticalView/Section';
import { Image, View, Text, StyleSheet, Link } from '@react-pdf/renderer';
import { EnvelopeWhiteIcon, PhoneWhiteIcon, TelegramWhiteIcon, WhatsappWhiteIcon, InstagramWhiteIcon, LinkedinWhiteIcon} from '@/assets/pdf';
import moment from 'moment';
import { SocialIcon } from './SocialIcon';
import { ReactNode } from 'react';
import { Style } from '@react-pdf/types';

interface IconTextProps {
  link?: string;
  iconSrc?: string;
  children?: ReactNode;
  style?: Style;
  wh?: number;
  size?: string;
  fontWeight?: number;
}

export const ContactSection = ({ contactInfo, showBroker, showAgency }: { contactInfo?: AdCreatorType | UserModel, showBroker?: boolean, showAgency?: boolean }) => {
  if (!contactInfo) return null;

  const { name, additionalPhones, additionalEmails, linkedin, whatsapp, telegram, instagram, kind, employer } = contactInfo;
  const createdTime = new Date();

  let avatarSrc;
  if ('avatar' in contactInfo) {
    avatarSrc = contactInfo.avatar;
  } else if (Array.isArray(contactInfo.media) && contactInfo.media[0]) {
    avatarSrc = contactInfo.media[0].fileUrl;
  }

  const formatDate = (value: string | null | Date) =>
    value !== null ? moment(value).format('D MMMM YYYY, H:mm') : null;

  const breakName = (name: string): string[] => [name];

  return (
    <Section>
      {(showBroker || showAgency) && <View 
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          backgroundColor: '#1650FF',
          padding: '50px 40px',
          color: '#fff',
          gap: '50px'
        }}
      >
          {showBroker && <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
            <Text
              style={{
                textTransform: 'uppercase',
                fontWeight: 700,
                fontSize: 80,
                flexWrap: 'wrap'
              }}
              hyphenationCallback={e => breakName(e)}
            >
              {name}
            </Text>
            <Text
              style={{
                fontSize: 34,
              }}
            >
              CREATED {formatDate(createdTime)}
            </Text>
          </View>}
          {showBroker && <View>
              <View style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', gap: '12px' }}>
                {additionalPhones && (
                  <IconText iconSrc={PhoneWhiteIcon} wh={60} size={'50px'} fontWeight={600} link={`tel:${additionalPhones?.[0]}`}>
                    {additionalPhones[0]}
                  </IconText>
                )}
                {additionalEmails && (
                  <IconText iconSrc={EnvelopeWhiteIcon} wh={60} size={'50px'} fontWeight={600} link={`mailto:${additionalEmails?.[0]}`}>
                    {additionalEmails[0]}
                  </IconText>
                )}
              </View>
            </View>
          }
        <View>
          {showBroker && 
            <View style={{display: 'flex', width: '100%', flexDirection: 'row', gap: '33px', justifyContent: 'center'}}>
              {linkedin && <SocialIcon iconSrc={LinkedinWhiteIcon} link={linkedin}/>}
              {instagram && <SocialIcon iconSrc={InstagramWhiteIcon} link={instagram}/>}
              {whatsapp && <SocialIcon iconSrc={WhatsappWhiteIcon} link={`https://wa.me/${whatsapp}`}/>}
              {telegram && <SocialIcon iconSrc={TelegramWhiteIcon} link={`https://t.me/${telegram}`}/>}
            </View>
          }
          
        </View>
        <View>
          {showAgency && 
            <View style={{display: 'flex', flexDirection: 'column'}}>
              <Text
                style={{
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  fontSize: 60,
                  textAlign: 'right',
                }}
                hyphenationCallback={e => breakName(e)}
              >
                {employer?.name}
              </Text>
              <Text
                style={{
                  fontSize: 40,
                  textAlign: 'right',
                }}
              >
                LICENSE AGENCY
              </Text>
            </View>
          }
        </View>
      </View>}
    </Section>
  );
};


const IconText = ({ link, iconSrc, children, style, wh = 50, size = '40px', fontWeight = 400 }: IconTextProps) => {
  if (!children) return null;

  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 16,
      color: '#2A3842',
      ...style,
    },
    icon: {
      width: wh,
      height: wh,
    },
    link: {
      fontSize: size,
      fontWeight: fontWeight,
      color: '#fff',
      textDecoration: 'none',
    }
  });

  return (
    <View style={styles.container}>
      {iconSrc && <Image src={iconSrc} style={styles.icon} />}
      <Link style={styles.link} src={link}>{children}</Link>
    </View>
  );
};
